import React from "react";

export default function Services({ services }) {
  return (
    <div className="container mx-auto p-4">
      <h1
        className="text-4xl font-bold text-gray-900 mb-8 text-center"
        data-aos="fade-right"
      >
        Services We Offer
      </h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {services.map((service, index) => (
          <div
            key={service.id}
            className="service-item mb-6 p-6 rounded-lg shadow-lg bg-white transition-transform transform hover:scale-105 cursor-pointer"
            onClick={() => console.log("Service clicked")}
            data-aos="fade-up"
            data-aos-duration="500"
            data-aos-easing="ease-in-out"
            data-aos-delay={index * 100} // Add delay based on index for staggered effect
          >
            <div className="flex items-center">
              <div className="service-number text-3xl font-bold text-indigo-600 mr-4">
                {service.number}
              </div>
              <div className="service-title text-xl font-semibold text-gray-800">
                {service.title}
              </div>
              <div className="service-image ml-auto">
                <img
                  src={service.imageUrl}
                  alt={`${service.title} example`}
                  className="w-16 h-16 object-cover rounded-full border-2 border-indigo-600 shadow-md"
                />
              </div>
            </div>
            <div className="mt-4 text-gray-700">
              <p className="text-base">{service.description}</p>
            </div>
          </div>
        ))}
      </div>

      <style jsx>{`
        .service-item {
          perspective: 1000px;
        }

        .service-item:hover {
          transform: rotateY(10deg) scale(1.05);
          transition: transform 0.3s ease;
        }
      `}</style>
    </div>
  );
}
